import { IWarehouse } from '@app/core/locations/store/locations.model';
import { IBinLocation } from 'v2/modules/location';

import { IRfq } from './../../rfq/interfaces/rfq.interface';
export interface IReceivingReportState {
  loading :boolean;
  submitting :boolean;
  receivingReports :any[]; // TODO: Define the type
  currentReceivingReport :any;
  loadingReceivableOrders :boolean;
  receivablesOrder :IReceivableOrder;
}
export interface IReceivableOrder {
  label :string;
  supplierPurchaseOrder :SupplierPurchaseOrder;
  supplierPurchaseOrderItems :OrderItem[];
  extraCosts :any[];
  supplierPurchaseOrderShipmentId ?:number;
  supplierPurchaseOrderShipment ?:{
    id :number;
    warehouseId ?:number;
    warehouse ?:IWarehouse & {
      defaultReceivingLocation ?:any;
    };
  };
}

export interface SupplierPurchaseOrder {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  orderDate :string;
  factoryId :number;
  orderType :number;
  logisticCode :string;
  logisticLabel :string;
  itemCount :number;
  orderQuantity :string;
  orderCost :number;
  totalTax :number;
  totalCost :number;
  totalPaid :number;
  totalShippingCost :number;
  downPayment :number;
  orderStatusId :number;
  orderStatusText :string;
  orderStatusDate :string;
  paymentTerms :string;
  publicNote :string;
  privateNote :string;
  trackingInfo :null;
  requestedShipDate :string;
  arrivalDueDate :string;
  dueAmount :number;
  dueDate :string;
  starred :number;
  starredNotes :null;
  syncInSkuVault :number;
  landedDomestic :number;
  landedIntl :number;
  intlShipping :null;
  streetAddressOne :string;
  streetAddressTwo :string;
  city :string;
  state :string;
  zip :string;
  country :string;
  locationId :number;
  warehouseId :number;
  defaultShipToAddress :string;
  internalResourceId :null;
  internalResourceType :null;
  supplierOrderType :string;
  quickbooksPurchaseOrderId :null;
  quickbooksDetailedMessage :null;
  orderItems :OrderItem[];
  internalResource ?:IInternalResouce;
}

export interface OrderItem {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  supplierPurchaseOrderId :number;
  internalSku :string;
  sourceSku :string;
  productName :string;
  productDescription :string;
  quantity :string;
  shipmentQuantity :string | null;
  unit :string;
  variantJson :null;
  variantLabel :null;
  variantValue :null;
  unitPrice :number;
  tax :number;
  discountAmount :number;
  discountPercent :number;
  downPaymentAmount :number;
  downPaymentPercent :number;
  lineTotal :number;
  rfqId :number;
  productTypeId :number;
  shippingUnitCost :number;
  stockId :number;
  order :null;
  orderedQuantity :string;
  baseUomId :number;
  orderedUomId :number;
  receivedQuantity :string;
  description :null;
  internalResourceItemId :null;
  internalResourceItemType :null;
  lotId :null;
  rfq :Rfq;
  stock :Stock;
  receivableUnitOfMeasure :OrderedUnitOfMeasure;
  supplierPurchaseOrder ?:SupplierPurchaseOrder;
  receivedEntry :IReceivedEntry;
}

interface IReceivedEntry {
  id :number;
  purchase_order_id :number;
  purchase_order_rfq_id :number;
  quantity :string;
  line_total :number;
}

interface OrderedUnitOfMeasure {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  unitClassId :number;
  name :string;
  description :string;
  baseUnit :boolean;
}

interface IInternalResouce {
  id :number;
  sourceWarehouseId :number;
  sourceWarehouse :IBinLocation;
  destinationWarehouseId :number;
  destinationWarehouse :IBinLocation;
  locationName :string;
  orderNumber :string;
  shippingCost :string;
  shippingMethod :string;
}

interface Stock {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :null;
  rfq_id :number;
  sku :string;
  onHandQuantity :string;
  onHoldQuantity :string;
  pickedQuantity :string;
  pendingQuantity :string;
  availableQuantity :string;
  incomingQuantity :string;
  inboundQuantity :string;
  transferQuantity :string;
  inStockQuantity :string;
  totalFbaQuantity :string;
  lastQuantitySync :string;
  warehouseId :number;
  locationId :number;
  warehouse :IWarehouse;
}

interface Rfq {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  statusCode :number;
  businessAccountId :number;
  productName :string;
  internalSku :string;
  productDescription :string;
  unitsQtyAnnual :number;
  unitsQtyFirst :number;
  targetPrice :number;
  retailPrice :number;
  wholesalePrice :number;
  productCategoryId :number;
  productCategory :string;
  willPurchaseSample :number;
  isProductInMarket :boolean;
  productLink :string;
  destinationAddress :string;
  destinationCity :string;
  destinationState :string;
  destinationZip :string;
  hasPrototype :boolean;
  hasPackingReq :boolean;
  otherDetails :string;
  photo :string;
  quotationsCount :number;
  addedBy :number;
  updatedBy :number;
  prevStatus :string;
  purchaseOrderDt :null;
  sampleOrderDt :null;
  prLabelingStickers :number;
  prCustomPrinting :number;
  prBundling :number;
  prVariousPrep :number;
  prCartonArrangement :number;
  prSameAsLink :number;
  prGenericQuote :number;
  prLabelingStickersText :string;
  prCustomPrintingText :string;
  prBundlingText :string;
  prVariousPrepText :string;
  prCartonArrangementText :string;
  prGenericQuoteText :string;
  odSampleToMatch :number;
  odSoldOnAmazon :number;
  odProProductPictures :number;
  odNeedHelpInPrototype :number;
  odNeedGraphicDesign :number;
  odSpecialCertificates :number;
  odInfoDetails :string;
  unitsQtyAnnualType :number;
  addressNotKnown :number;
  changesToMake :string;
  developmentStatus :string;
  unitsQtyMoq :number;
  brandProduct :number;
  artworkAvailable :number;
  productHasVariants :number;
  productVariants :string;
  rfqQuoteType :number;
  teamLoginId :number;
  volumeFirstOrder :number;
  volumeAnnualOrder :number;
  starred :number;
  starredNotes :string;
  pipelineStatus :string;
  productTypeId :number;
  productType :string;
  qtyOnhand :number;
  qtyOnhold :string;
  qtyPicked :string;
  qtyPending :string;
  qtyAvailable :string;
  qtyIncoming :string;
  qtyInbound :string;
  qtyTransfer :string;
  qtyInstock :string;
  qtyTotalfba :string;
  lastQtysSync :string;
  sourceType :number;
  skuvaultProductId :string;
  productDeptId :number;
  productDept :string;
  isPalletized :boolean;
  cartonsPerPallet :number;
  shipmentValue :number;
  toAddress :string;
  fromAddress :string;
  boxWeight :string;
  boxLength :number;
  boxWidth :number;
  boxHeight :number;
  cartonWeight :string;
  cartonLength :number;
  cartonWidth :number;
  cartonHeight :number;
  isDiscontinued :boolean;
  reorderLevel :number;
  qtyLimitNotify :number;
  productWeight :string;
  packageCost :number;
  laborCost :number;
  shippingWeight :string;
  dimensionalWeight :string;
  internalUseOnly :number;
  efficiencyScore :number;
  defaultShipping :number;
  productDesign :string;
  ossLimitNotify :number;
  materials :string;
  customFields :string;
  masterSkuId :string;
  subCategoryId :number;
  subCategory :string;
  variantParentId :number;
  preferredVendorId :number;
  discountStructure :null;
  expiresAt :null;
  palletWeight :string;
  palletWidth :number;
  palletHeight :number;
  palletLength :number;
  unitsPerCarton :number;
  unitsPerPallet :number;
  shippingLength :number;
  shippingWidth :number;
  shippingHeight :number;
  productLength :number;
  productWidth :number;
  productHeight :number;
  markupStructure :null;
  mirrorInventoryFromParent :number;
  upc :null;
  sellable :boolean;
  totalVariantSkus :number;
  defaultSellingUnitId :number;
  defaultPurchaseUnitId :number;
  unitClassId :number;
  type :string;
  defaultReceivingBinId :number;
  defaultReceivingBin :DefaultReceivingBin;
  discountStructreSelectedRfq :boolean;
  priceScheduleId :number;
  lotTracking :boolean;
  salesVelocity :number;
  mostRecentRunningBalance :null;
}

interface DefaultReceivingBin {
  id :number;
  createdAt :string;
  updatedAt :string;
  deletedAt :null;
  createdBy :number;
  updatedBy :number;
  deletedBy :null;
  status :string;
  locationName :string;
  parentId :number;
  address :null;
  country :null;
  zip :null;
  state :null;
  city :null;
  streetAddress1 :null;
  streetAddress2 :null;
  meta :null;
}

export enum EReceivingReportFilterBy {
  PURCHASE_ORDER_ID = 'supplier_purchase_order_id',
  SHIPMENT_REFERENCE_NUMBER = 'supplier_purchase_order_shipment_reference_number',
  SKU = 'sku',
  ALTERNATIVE_SKU = 'alternate_sku',
}
